import type { WidgetProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const SelectWidget = ({
  disabled,
  id,
  onChange,
  uiSchema,
  options: { enumOptions: options },
  placeholder,
  required,
  value
}: WidgetProps) => {
  const selectedValues = Array.isArray(value)
    ? new Set(value.map(String))
    : null
  const selected = options
    ?.filter((o) =>
      selectedValues
        ? selectedValues.has(String(o.value))
        : `${o.value}` === `${value}`
    )
    .map(({ label, value }) => ({ label, value: String(value) })) // Convert value to string for HTML compatibility

  return (
    <Mtds.Field.Suggestion
      data-placement={uiSchema?.['ui:options']?.placement}
      selected={selected}
      onSelectedChange={([item]) => {
        onChange(options?.find((o) => `${o.value}` === `${item?.value}`)?.value) // Get original value format
      }}
    >
      <Mtds.Input
        disabled={disabled}
        id={id}
        placeholder={placeholder}
        required={required}
      />
      <button type='reset' aria-label='Fjern tekst' />
      <Mtds.Field.Datalist>
        {options?.map(({ label, value }) => (
          <Mtds.Field.Option key={value} value={value}>
            {label}
          </Mtds.Field.Option>
        ))}
      </Mtds.Field.Datalist>
    </Mtds.Field.Suggestion>
  )
}
